<template>
  <!-- 模版导航栏 -->
  <div class="template-navbar">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <el-input
        v-model="searchKeyword"
        placeholder="搜索模块"
        class="search-input"
        prefix-icon="el-icon-search"
        @input="handleSearch"
      >
      </el-input>
      <el-button
        type="primary"
        size="mini"
        class="buttonSearch"
        @click="handleQuery"
        >搜索</el-button
      >
    </div>
    <!-- 分类标签 -->
    <div class="category-tabs">
      <div
        v-for="(category, index) in categories"
        :key="index"
        @click="oncategory(category)"
        :class="{ categoryactive: category.industryId == activeCategory }"
        style="
          cursor: pointer;
          margin-bottom: 5px;
          padding: 5px 5px;
          height: 29px;
          border-radius: 5px;
        "
      >
        {{ category.industryName }}
      </div>
    </div>
    <div class="content-grid">
      <div
        v-for="(item, index) in contentItems"
        :key="index"
        class="content-item"
        :class="{ 'content-item-active': tweetId == item.twTemplateId }"
        @mouseenter="hoverIndex = index"
        @mouseleave="hoverIndex = -1"
        @click="emitOnclick(item)"
      >
        <div class="image-container">
          <img :src="item.imageUrl" style="height: 165px; width: 100%" alt="" />
          <div class="hover-mask" v-show="hoverIndex === index">
            <div class="action-buttons">
              <el-button
                type="primary"
                size="mini"
                class="buttonSearch"
                @click.stop="handlePreview(item)"
                >预览</el-button
              >

              <el-button
                type="danger"
                size="mini"
                @click.stop="handleDelete(item)"
              >
                删除
              </el-button>
            </div>
          </div>
        </div>

        <div style="padding: 0 10px">
          <div style="font-size: 14px">
            {{ item.name }}
          </div>
          <div
            style="
              display: flex;
              font-size: 14px;
              justify-content: space-between;
            "
          >
            <div
              style="
                background-color: #fff0e9;
                padding: 0 5px;
                color: #ff7225;
                border-radius: 5px;
              "
            >
              {{ getCategoryName(item.industryId) }}
            </div>
            <div>
              <span style="color: #ff7225">￥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty
      v-if="contentItems.length === 0"
      :image-size="200"
      style="margin-top: 50px"
    ></el-empty>
  </div>
</template>
<script>
export default {
  name: "TemplateNavbar",
  props: {},
  data() {
    return {
      contentItems: [],
      tweetId: 0,
      hoverIndex: -1, // 悬浮状态索引
      searchKeyword: "",
      activeCategory: "all",
      categories: [],
    };
  },
  created() {
    // this.industry();
  },
  methods: {
    async industry() {
      const res = await this.$store.dispatch("dataCache/fetchIndustryListData");
      this.categories = [
        { industryId: "all", industryName: "全部" },
        ...this.$utils.handleTree(res, "industryId", "parentId"),
      ];
      console.log("leftTweet子组件获取行业分类数据----", this.categories);
    },
    handleSearch() {
      console.log("搜索关键词:", this.searchKeyword);
    },
    handleQuery() {
      // 搜索逻辑
    },
    emitOnclick(rows) {
      console.log(999);
      this.tweetId = rows.twTemplateId;
      this.$emit("templateUpdate", rows);
    },
    // 获取分类名称
    getCategoryName(industryId) {
      const category = this.categories.find(
        (el) => el.industryId === industryId,
      );
      return category ? category.industryName : "";
    },
    oncategory(item) {
      console.log("分类点击", item);
      this.activeCategory = item.industryId;
      this.$emit("changeTab", item);

      return;
      this.getList();
    },
    // 预览方法
    handlePreview(item) {
      console.log("预览项目:", item);
      this.$emit("preview", item);
    },

    // 删除方法
    handleDelete(item) {
      let T = 0;
      if (item.twTemplateId == this.tweetId) {
        T = 1;
      }
      this.$confirm(
        T == 0
          ? "确定要删除这个项目吗？"
          : "当前模版正在编辑，确定要删除这个项目吗？",
        "提示",
        {
          type: "warning",
        },
      )
        .then(async () => {
          try {
            // 调用删除接口
            await deleteItem(item.twTemplateId);
            this.$message.success("删除成功");

            if (T == 1) {
              this.$emit("templateUpdate", {});
            }
            this.getList(); // 重新加载列表
          } catch (error) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {
          // 用户取消删除
        });
    },
  },
};
</script>
<style scoped lang="scss">
.template-navbar {
  border: 2px solid red;

  /* 内容网格样式 */
  .content-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 3px;
    max-height: 670px;
    overflow: auto;
  }

  /* 隐藏滚动条但保持功能 */
  // .content-grid::-webkit-scrollbar {
  //   display: none;
  // }

  /* 空状态样式 */
  .empty-state {
    grid-column: 1 / -1;
    margin: 40px 0;
    text-align: center;
    color: #999;
  }
  /* 搜索栏样式 */
  .search-bar {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
  }

  .search-input {
    ::v-deep .el-input__inner {
      height: 30px !important;
      line-height: 30px;
    }
    ::v-deep .el-input__icon {
      line-height: 30px;
    }
  }

  .buttonSearch {
    background-color: #348cf8;
    height: 29px;
    border-radius: 6px;
    margin-left: 5px;
    border-color: #348cf8;
  }

  /* 分类标签样式 */
  .category-tabs {
    margin-bottom: 24px;
    font-size: 14px;
    display: flex;
    gap: 0 37px;
    flex-wrap: wrap;
    justify-content: flex-start;

    .categoryactive {
      background-color: #edf0fc;
      color: #4c6ee2;
    }
  }
}
</style>
